<div class="card-flip" [class.active]="showingDetails">
    <div class="flip">
        <div class="front">
            <!-- front content -->
            <div class="card reduced-padding">
                <div class="button-bar pull-right member-links">
                    <a class="text-primary"
                       (click)="hybridToolsService.openExternalLink(member.fullUrl)" target="_blank" *ngIf="member.fullUrl">View Page</a>
                    <span class="link-separator" *ngIf="member.fullUrl">|</span>
                    <a class="text-primary" (click)="showingDetails = true" href="javascript:void(0)">Details</a>
                </div>
                <img class="card-img-left img-fluid" *ngIf="member.imagePath" src="{{imageService.formatUrl(member.imagePath)}}">
                <!-- This image src need be changed to not gender one-->
                <img class="card-img-left img-fluid" *ngIf="!member.imagePath && !member.prefixType"
                     src="assets/modules/dummy-assets/common/img/avatars/default-avatar.jpg">
                <img class="card-img-left img-fluid"
                     *ngIf="!member.imagePath && member.prefixType && member.prefixType.name === 'MR'"
                     src="assets/modules/dummy-assets/common/img/avatars/default-avatar-m.jpg">
                <img class="card-img-left img-fluid"
                     *ngIf="!member.imagePath && member.prefixType && (member.prefixType.name === 'MS' || member.prefixType.name === 'MRS'
                     || member.prefixType.name === 'MISS')"
                     src="assets/modules/dummy-assets/common/img/avatars/default-avatar-f.jpg">
                <div class="card-body">
                    <div>
                        <div class="row">
                            <div class="col-6">
                                <h4 class="card-title text-black">{{member?.firstName}} {{member?.lastName}}</h4>
                            </div>
                            <div class="col-6">
                                <h4 class="card-title">
                                    <span class="pull-right font-number text-black" *ngIf="isWidgetVisible">
                                        {{member?.grandTotal | currency:'USD':true}}
                                    </span>
                                </h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <p class="card-text mb-3">
                                    <a class="text" [href]="'mailto:' + member?.email">{{ member?.email}}</a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="back">
            <!-- back content -->
            <div class="card">
                <div class="card-body p-0">
                    <div>
                        <div class="row">
                            <div class="col-5">
                                <p class="card-text text-black member-email">Email:<br/>
                                    <a class="text-primary" [href]="'mailto:' + member?.email"> {{member?.email}}</a>
                                </p>
                                <p class="card-text text-black">Phone:<br/>
                                    <a [href]="'tel:' + member.areaCode + member.phoneNumber" class="text-primary">
                                        <span *ngIf="member?.areaCode">({{member?.areaCode}}) -</span>
                                        <span *ngIf="member?.phoneNumber">{{member?.phoneNumber}}</span>
                                    </a>
                                </p>
                                <p class="card-text">
                                    <span class="text-black">Honoree:</span><br/>
                                    <span *ngIf="member?.honoree">{{member?.honoree}}</span>
                                </p>
                            </div>
                            <div class="col-7">
                                <div class="float-sm-right donations" *ngIf="isWidgetVisible">
                                    <p class="text-black">
                                        <label><b>Raised:</b></label>
                                        <span><b>{{member?.grandTotal | currency:'USD':true}}</b></span>
                                    </p>
                                    <p>
                                        <label class="d-none d-sm-inline-block">Funds from LLS Fundraising Page:</label>
                                        <label class="d-sm-none">LLS Fundraising:</label>
                                        <span>{{member?.totalFunds | currency:'USD':true}}</span>
                                    </p>
                                    <p *ngIf="!member?.teamCard">
                                        <label class="d-none d-sm-inline-block">Facebook Funds:</label>
                                        <label class="d-sm-none">Facebook:</label>
                                        <span>{{member?.facebookFunds | currency:'USD':true}}</span>
                                    </p>
                                    <p>
                                        <label>Promises:</label>
                                        <span>{{member?.outstandingMatchingGifts | currency:'USD':true}}</span>
                                    </p>
                                    <p *ngIf="!!member?.teamCard">
                                        <label>Sponsorships:</label>
                                        <span>{{member?.outstandingSponsorships | currency:'USD':true}}</span>
                                    </p>
                                    <p class="text-black">
                                        <label>Registration Status:</label>
                                        <span>{{member?.registrationStatusTypeDescription}}</span>
                                    </p>
                                </div>
                                <i (click)="showingDetails = false" style="position:absolute;top:0px;right:5px;font-size:18px" class="cursor-hand fa fa-close"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
